<script>
  import FontSizeDecorator from '$components/SanityComponents/PortableText/Decorators/FontSizeDecorator.svelte';
  import { analyticsStore, PreferenceState } from '$lib/analytics/store';
  import { onMount } from 'svelte';
  import { page } from '$app/stores';
  import NavItem from '$components/Navigation/NavItem.svelte';
  import { ResponsiveVars } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { cx } from '@emotion/css';

  const unlockPage = () => {
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('pointer-events');
  };

  const lockPage = () => {
    document.body.style.overflow = 'hidden';
    document.body.style.pointerEvents = 'none';
  };

  const handleLock = () => {
    if (
      $page.url.pathname !== '/cookie-policy' &&
      $analyticsStore.shouldRequestConsent === PreferenceState.Yes
    ) {
      lockPage();
    } else {
      unlockPage();
    }
  };

  onMount(() => {
    handleLock();
  });

  $effect(() => {
    handleLock();
  });

  const responsiveVars = new ResponsiveVars()
    .addFluid('font-size', toFluidVarInput(12, 12))
    .addFluid('gap', toFluidVarInput(21, 0))
    .addFluid('button-gap', toFluidVarInput(21, 36))
    .addFluid('py', toFluidVarInput(24, 24))
    .addFluid('text-px', toFluidVarInput(27, 0))
    .addFluid('button-py', toFluidVarInput(9, 0))
    .toCSS();
</script>

{#if $analyticsStore.shouldRequestConsent === PreferenceState.Yes}
  <div class={cx('container', 'cookie-banner', responsiveVars)}>
    <p>
      <FontSizeDecorator size="caption" inverse>
        We use cookies to gather basic analytics on how visitors use our website.
      </FontSizeDecorator>
    </p>
    <div class="actions">
      <NavItem
        as="button"
        text="Accept"
        type="button"
        onClick={analyticsStore.acceptAnalytics}
        inverse={true}
      />
      <NavItem
        as="button"
        text="Decline"
        type="button"
        onClick={analyticsStore.declineAnalytics}
        inverse={true}
      />
      <NavItem href="/cookie-policy" text="Read more" rel="external" inverse={true} />
    </div>
  </div>
  {#if $page.url.pathname !== '/cookie-policy'}
    <div class="overlay"></div>
  {/if}
{/if}

<style lang="scss">
  @import 'src/scss/media';
  @import 'src/scss/variables';

  .cookie-banner {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: $background-inverse-color;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: var(--gap);
    z-index: map-get($zIndex, cookie-banner);
    pointer-events: auto;

    @include at('lg') {
      flex-direction: row;
    }

    .actions {
      display: flex;
      gap: var(--button-gap);
      padding-bottom: var(--py);

      @include at('lg') {
        padding: 0;
      }
    }

    p {
      color: $text-inverse-color;
      padding: var(--py) var(--text-px) 0;
      text-align: center;

      @include at('lg') {
        padding: var(--py) 0;
      }
    }
  }

  .overlay {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: $background-transparent-color;
    z-index: map-get($zIndex, cookie-banner-overlay);
    pointer-events: none;
  }
</style>
